import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ContractsAPI } from "../../api/contracts";

export default function ContractList() {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    ContractsAPI.list()
      .then(setContracts)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading contracts...</p>;
  if (error) return <p className="text-red-500">Error: {error}</p>;

  return (
    <div>
      <h1 className="text-xl font-bold mb-4">Contracts</h1>
      <Link
        to="/contracts/new"
        className="bg-green-600 text-white px-3 py-1 rounded"
      >
        + New Contract
      </Link>
      <table className="w-full border mt-4">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 text-left">Supplier</th>
            <th className="p-2 text-left">Service</th>
            <th className="p-2">Start</th>
            <th className="p-2">End</th>
            <th className="p-2">Annual Cost</th>
            <th className="p-2">Total Cost</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {contracts.map((c) => (
            <tr key={c.id} className="border-t">
              <td className="p-2">{c.supplier_name}</td>
              <td className="p-2">{c.service_description}</td>
              <td className="p-2">{c.start_date?.slice(0, 10)}</td>
              <td className="p-2">{c.end_date?.slice(0, 10)}</td>
              <td className="p-2">£{c.annual_cost}</td>
              <td className="p-2">£{c.total_cost}</td>
              <td className="p-2">
                <Link
                  to={`/contracts/${c.id}`}
                  className="text-blue-600 hover:underline"
                >
                  Edit
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}